import ViewPDFPage from '../../pages/ViewPDFPage/ViewPDFPage';
import FormContainer from '../../pages/FormPage/FormContainer';

export const getStepContent = (step ,signCanOverwrite , agentRestricted) => {
    switch (step) {
      case 0:
        return <FormContainer />
      case 1:
        // download, view, share file
        return <ViewPDFPage 
            isOverwriteSignature={signCanOverwrite} 
            isAgentRestricted={agentRestricted}  
            step={step}
          />
      case 2:
        // upload and sign file
        return <ViewPDFPage 
          isOverwriteSignature={signCanOverwrite} 
          isAgentRestricted={agentRestricted}  
          step={step}
        />
        
      default:
        throw new Error('Unknown step');
    }
  }

